// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Mcp — MCP 도구 영역
   사이드바·인트로 공통 스타일은 Prompt.css 재사용 (.prompt__sidebar / .prompt-intro__*)
   비교 표는 Knowledge.css의 .knowledge-intro__vs-* 재사용
   ======================================================================== */

/* ───────── ON/OFF 비교 카드 ───────── */
.mcp-intro__onoff-grid-outer {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.mcp-intro__onoff {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.mcp-intro__onoff-head {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.mcp-intro__onoff-q-icon {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  color: var(--fg-text-basic);
}

.mcp-intro__onoff-question {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1.5;
}

.mcp-intro__onoff-source {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--fg-text-gray);
}

.mcp-intro__onoff-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.mcp-intro__onoff-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: var(--fg-bg-card);
  border-radius: 8px;
}

.mcp-intro__onoff-col--on {
  background: var(--fg-bg-vs-green);
}

.mcp-intro__onoff-col p {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-basic);
}

.mcp-intro__onoff-label {
  align-self: flex-start;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.mcp-intro__onoff-label--off {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-text-gray);
}

.mcp-intro__onoff-label--on {
  background: rgba(98, 147, 81, 0.15);
  color: var(--fg-class-green);
}


/* ========================================================================
   McpList — 내 MCP 목록 (Figma 75:9500)
   ======================================================================== */

.mcp-list__cards {
  display: grid;
  gap: 20px;
}

.mcp-list__cards--grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.mcp-list__cards--list {
  grid-template-columns: 1fr;
}

@media (max-width: 1440px) {
  .mcp-list__cards--grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 1280px) {
  .mcp-list__cards--grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}


.mcp-list__card {
  display: flex;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.mcp-list__card:hover {
  border-color: var(--fg-button);
}

.mcp-list__card--selected {
  border-color: var(--fg-side-hover);
  box-shadow: 0 0 0 1px var(--fg-side-hover);
}

.mcp-list__card-check {
  flex-shrink: 0;
  padding-top: 4px;
}

.mcp-list__card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mcp-list__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mcp-list__card-title {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mcp-list__card-date {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.mcp-list__card-sub {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.mcp-list__tools {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.mcp-list__tool {
  padding: 4px 6px;
  background: var(--fg-bg-liteblue);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.mcp-list__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}

/* ========================================================================
   McpGenerator — AI MCP 생성 (Figma 75:9010)
   ======================================================================== */

.mcp-gen__main {
  display: flex;
  padding: 0;
  overflow: hidden;
  /* layout 의 min-height 와 동일하게 강제 — 콘텐츠가 늘어나도 page scroll 이 생기지 않도록 */
  height: calc(100vh - 52px);
}

/* 좌측 작성 패널 */
.mcp-gen__composer {
  width: 360px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 30px 24px;
  background: var(--fg-bg-card);
  border-right: 1px solid var(--fg-line);
  overflow-y: auto;
}

.mcp-gen__composer-head {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mcp-gen__composer-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--fg-text-basic);
  flex: 1 1;
}

.mcp-gen__composer-lead {
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-gray);
}

.mcp-gen__composer-label {
  margin: 8px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-gen__composer-btn {
  align-self: stretch;
  justify-content: center;
}

.mcp-gen__suggestions {
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mcp-gen__suggestion {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-gen__suggestion:hover {
  border-color: var(--fg-button);
}

.mcp-gen__suggestion-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mcp-gen__suggestion-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-gen__suggestion-summary {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
  line-height: 1.5;
}

/* 우측 캔버스 */
.mcp-gen__canvas {
  /* flex: 6 1 0; */
  width:50%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.mcp-gen__canvas-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 8px 16px;
  background: var(--fg-bg-toolbar);
  border-bottom: 1px solid var(--fg-line);
  flex-shrink: 0;
  gap: 8px;
}

.mcp-gen__canvas-toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.mcp-gen__canvas-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.mcp-gen__canvas-toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* 세그먼트 그룹 (탭처럼 묶인 chip 묶음) */
.mcp-gen__chip-group {
  display: inline-flex;
  align-items: center;
  gap: 1px;
}

.mcp-gen__chip-group .mcp-gen__chip--seg {
  border-radius: 0;
}

.mcp-gen__chip-group .mcp-gen__chip--seg:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.mcp-gen__chip-group .mcp-gen__chip--seg:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* 기본 chip — lite 배경 + purple text */
.mcp-gen__chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  color: var(--fg-button-hover);
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-gen__chip:hover {
  filter: brightness(0.97);
}

.mcp-gen__chip--icon-only {
  padding: 5px 7px;
}

/* active 세그먼트 + primary 단독 — purple 배경 + white text */
.mcp-gen__chip--active,
.mcp-gen__chip--primary {
  background: var(--fg-button);
  color: #fff;
}

.mcp-gen__chip--active:hover,
.mcp-gen__chip--primary:hover {
  background: var(--fg-button-hover);
  color: #fff;
}

.mcp-gen__canvas-body--filled {
  display: block !important;
  padding: 24px;
}

.mcp-gen__form {
  max-width: 960px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mcp-gen__form-badge {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: var(--fg-bg-step-active);
  color: var(--fg-side-hover);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.mcp-gen__form-explanation {
  margin: 0;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-size: 13px;
  color: var(--fg-text-basic);
  line-height: 1.6;
  white-space: pre-wrap;
}

.mcp-gen__form-tools {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}

.mcp-gen__tool-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-gen__tool-card:hover {
  border-color: var(--fg-button);
}

.mcp-gen__tool-card--checked {
  background: var(--fg-bg-step-active);
  border-color: var(--fg-side-hover);
}

.mcp-gen__tool-check {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  background: #c2c2c2;
  border-radius: 4px;
  margin-top: 2px;
}

.mcp-gen__tool-card--checked .mcp-gen__tool-check {
  background: var(--fg-side-hover);
}

.mcp-gen__tool-card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mcp-gen__tool-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mcp-gen__tool-card-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-gen__tool-card-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: var(--fg-side-hover);
  color: #fff;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.mcp-gen__tool-card-desc {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
  line-height: 1.45;
}

.mcp-gen__tool-card-reason {
  margin: 4px 0 0;
  padding: 6px 8px;
  background: rgba(0, 0, 0, 0.03);
  border-left: 2px solid var(--fg-side-hover);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-text-basic);
  line-height: 1.5;
  white-space: pre-wrap;
}

.mcp-gen__canvas-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  background: #fafafa;
  padding: 40px;
  display: grid;
  place-items: center;
}

.mcp-gen__canvas-empty,
.mcp-gen__canvas-result {
  text-align: center;
  color: var(--fg-text-gray);
  font-size: 15px;
  line-height: 24px;
}

.mcp-gen__canvas-result p {
  margin: 0 0 8px;
}

.mcp-gen__hint {
  font-size: 13px;
  color: var(--fg-text-gray);
}

/* ========================================================================
   McpBuilder — 나만의 MCP 만들기 (Figma 75:9361)
   ======================================================================== */

.mcp-builder__panel {
  /* flex: 4 1 0; */
  width: 50%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background: var(--fg-bg-card);
  border-right: 1px solid var(--fg-line);
  overflow-y: auto;
}

.mcp-builder__panel-head {
  text-align: center;
  border-bottom: 1px solid var(--fg-line);
  padding-bottom: 12px;
}

.mcp-builder__panel-eyebrow {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-builder__panel-sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.mcp-builder__tabs {
  display: flex;
  border-bottom: 1px solid var(--fg-line);
}

.mcp-builder__tab {
  flex: 1 1;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  cursor: pointer;
  text-align: center;
  margin-bottom: -1px;
  transition: var(--transition-fast);
}

.mcp-builder__tab p {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.mcp-builder__tab-sub {
  font-size: 12px !important;
  color: var(--fg-text-gray) !important;
  margin-top: 2px !important;
}

.mcp-builder__tab--active {
  border-bottom-color: var(--fg-text-basic);
  font-weight: 600;
}

.mcp-builder__search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px 7px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
}

.mcp-builder__search>svg {
  flex-shrink: 0;
  color: var(--fg-text-gray);
}

.mcp-builder__count {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.mcp-builder__count b {
  color: var(--fg-button);
  font-weight: 700;
  margin-right: 2px;
}

.mcp-builder__count span {
  color: var(--fg-text-gray);
  margin-left: 2px;
}

.mcp-builder__count-cat {
  margin-left: 6px !important;
  color: var(--fg-button) !important;
  font-weight: 600;
}

/* 카테고리 필터 칩 */
.mcp-builder__cat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 4px 0 10px;
}

.mcp-builder__cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-builder__cat-chip:hover:not(:disabled) {
  border-color: var(--fg-button);
  color: var(--fg-button);
}

.mcp-builder__cat-chip--active {
  background: var(--fg-button);
  border-color: var(--fg-button);
  color: #fff;
}

.mcp-builder__cat-chip:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.mcp-builder__cat-chip-count {
  display: inline-grid;
  place-items: center;
  min-width: 18px;
  height: 16px;
  padding: 0 5px;
  background: var(--fg-bg-litepp);
  color: var(--fg-text-gray);
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;
  line-height: 1;
}

.mcp-builder__cat-chip--active .mcp-builder__cat-chip-count {
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
}

/* 도구 카드 그리드 (1열) */
.mcp-builder__tool-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 6px;
}

.mcp-builder__tool-card {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-builder__tool-card:hover {
  border-color: var(--fg-text-gray);
}

.mcp-builder__tool-card--selected {
  background: #fff;
  border-color: var(--fg-text-basic);
}

.mcp-builder__tool-check {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  color: var(--fg-text-gray);
}

.mcp-builder__tool-card--selected .mcp-builder__tool-check {
  color: var(--fg-text-basic);
}

.mcp-builder__tool-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mcp-builder__tool-title {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mcp-builder__tool-cat {
  flex-shrink: 0;
  align-self: flex-start;
  padding: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  color: #fff;
  background: var(--fg-text-gray);
  border-radius: 4px;
}

.mcp-builder__tool-cat--utility {
  background: #e48be3;
}

.mcp-builder__tool-cat--web {
  background: #67d3eb;
}

.mcp-builder__tool-cat--compute {
  background: #ff6e69;
}

.mcp-builder__tool-cat--file {
  background: #bab361;
}

.mcp-builder__tool-cat--realtime {
  background: #44e6ad;
}

.mcp-builder__tool-cat--external {
  background: #9b92e8;
}

.mcp-builder__tool-desc {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: var(--fg-text-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 일반 탭 폼 */
.mcp-builder__form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mcp-builder__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mcp-builder__field>span {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.mcp-builder__input,
.mcp-builder__textarea {
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-text-basic);
  outline: none;
  resize: vertical;
}

.mcp-builder__input:focus,
.mcp-builder__textarea:focus {
  border-color: var(--fg-button);
}

/* 우측 캔버스 본문 */
.mcp-builder__canvas-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 30px 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.mcp-builder__canvas-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.mcp-builder__canvas-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-builder__canvas-sub {
  margin: 4px 0 0;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.mcp-builder__canvas-count {
  flex-shrink: 0;
  padding: 6px 10px;
  background: var(--fg-bg-mychat);
  border-radius: 6px;
  font-size: 13px;
  color: var(--fg-button-hover);
}

.mcp-builder__canvas-count b {
  margin-left: 4px;
  font-weight: 700;
}

/* 선택된 도구 칩들 */
.mcp-builder__chip-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mcp-builder__selected-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 4px 10px;
  background: var(--fg-bg-mychat);
  border-radius: 6px;
  font-size: 13px;
  color: var(--fg-text-basic);
}

.mcp-builder__selected-chip button {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
  border-radius: 4px;
}

.mcp-builder__selected-chip button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-anti-red);
}

.mcp-builder__chip-empty {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

/* 실행 흐름 */
.mcp-builder__flow {
  margin-top: 12px;
}

.mcp-builder__flow-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.mcp-builder__flow-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mcp-builder__flow-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}

.mcp-builder__flow-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: var(--fg-numbering-bg);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  border-radius: 9999px;
}

.mcp-builder__flow-text {
  margin: 0;
  flex: 1 1;
  font-size: 15px;
  color: var(--fg-text-basic);
}

.mcp-builder__flow-tag {
  flex-shrink: 0;
  padding: 4px 8px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 6px;
  font-size: 12px;
  color: var(--fg-text-gray);
}

/* (MCP 공유 관리 모달 → src/components/ShareModal.js + src/css/ShareModal.css 로 이관) */

/* ========================================================================
   McpBuilder — 테스트 패널 (구성/테스트 모드 토글)
   ======================================================================== */

.mcp-builder__mode-tabs {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  background: var(--fg-bg-content);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
}

.mcp-builder__mode-tab {
  padding: 6px 14px;
  background: transparent;
  border: 0;
  border-radius: 7px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-builder__mode-tab:hover {
  color: var(--fg-text-basic);
}

.mcp-builder__mode-tab--active {
  background: #fff;
  color: var(--fg-text-basic);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.mcp-builder__canvas-body--test {
  gap: 12px;
  overflow: hidden;
  /* 부모의 overflow-y:auto를 끄고, 안쪽 scroller가 자체 스크롤 */
}

.mcp-builder__mcp-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.mcp-builder__mcp-toggle input {
  margin: 0;
  cursor: pointer;
  accent-color: var(--fg-button);
}

.mcp-builder__test-tools-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--fg-bg-content);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  flex-wrap: wrap;
}

.mcp-builder__test-tools-label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-gray);
  letter-spacing: 0.02em;
}

.mcp-builder__test-tools-label b {
  color: var(--fg-text-basic);
  font-weight: 700;
}

.mcp-builder__test-tools-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.mcp-builder__test-tools-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-basic);
  max-width: 220px;
}

.mcp-builder__test-tools-chip-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.mcp-builder__test-tools-chip-cat {
  flex-shrink: 0;
  padding: 1px 6px;
  background: var(--fg-bg-content);
  color: var(--fg-text-gray);
  font-size: 10px;
  font-weight: 600;
  border-radius: 999px;
  text-transform: lowercase;
}

.mcp-builder__test-notice {
  margin: 0;
  padding: 10px 14px;
  font-size: 13px;
  color: var(--fg-text-gray);
  background: var(--fg-bg-content);
  border: 1px dashed var(--fg-line);
  border-radius: 10px;
}

.mcp-builder__test-notice--warning {
  color: var(--fg-anti-red);
  background: rgba(239, 68, 68, 0.06);
  border-color: rgba(239, 68, 68, 0.3);
  border-style: solid;
}

.mcp-builder__test-scroller {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 4px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mcp-builder__test-empty {
  margin: auto;
  font-size: 14px;
  color: var(--fg-text-gray);
  text-align: center;
}

.mcp-builder__test-msg {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 88%;
}

.mcp-builder__test-msg--user {
  align-self: flex-end;
  align-items: flex-end;
}

.mcp-builder__test-msg--assistant {
  align-self: flex-start;
  align-items: flex-start;
}

.mcp-builder__test-steps {
  list-style: none;
  margin: 0 0 4px;
  padding: 10px 12px;
  background: var(--fg-bg-content);
  border: 1px solid var(--fg-line);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 520px;
}

.mcp-builder__test-step {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: var(--fg-text-basic);
}

.mcp-builder__test-step-num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  background: var(--fg-button);
  color: #fff;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
}

.mcp-builder__test-step-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.mcp-builder__test-step-action {
  margin: 0;
  font-weight: 600;
}

.mcp-builder__test-step-detail {
  margin: 0;
  color: var(--fg-text-gray);
}

.mcp-builder__test-bubble {
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 100%;
}

.mcp-builder__test-bubble--user {
  background: var(--fg-button);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.mcp-builder__test-bubble--assistant {
  background: #fff;
  color: var(--fg-text-basic);
  border: 1px solid var(--fg-line);
  border-bottom-left-radius: 4px;
}

.mcp-builder__test-bubble--error {
  border-color: rgba(239, 68, 68, 0.4);
  color: var(--fg-anti-red);
}

.mcp-builder__test-bubble--pending {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 12px 14px;
}

.mcp-builder__test-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--fg-text-gray);
  animation: mcpTestBounce 1.2s infinite ease-in-out;
}

.mcp-builder__test-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.mcp-builder__test-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes mcpTestBounce {

  0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.5;
  }

  30% {
    transform: translateY(-4px);
    opacity: 1;
  }
}

.mcp-builder__test-tools {
  margin: 0 0 6px;
  font-size: 11px;
  font-weight: 700;
  color: var(--fg-button);
  letter-spacing: 0.02em;
}

.mcp-builder__test-text {
  margin: 0;
}

.mcp-builder__test-images {
  margin-top: 8px;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.mcp-builder__test-image {
  max-width: 240px;
  max-height: 200px;
  border-radius: 8px;
  border: 1px solid var(--fg-line);
  object-fit: contain;
  background: #fff;
}

.mcp-builder__test-inputbar {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 10px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 14px;
}

.mcp-builder__test-input {
  flex: 1 1;
  min-height: 40px;
  max-height: 160px;
  padding: 8px 10px;
  background: transparent;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-basic);
  resize: none;
}

.mcp-builder__test-input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mcp-builder__test-send {
  flex-shrink: 0;
  padding: 9px 16px;
  background: var(--fg-button);
  color: #fff;
  border: 0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: var(--transition-fast);
}

.mcp-builder__test-send:hover:not(:disabled) {
  filter: brightness(1.06);
  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);
}

.mcp-builder__test-send:disabled {
  background: var(--fg-text-gray);
  cursor: not-allowed;
}

/* ========================================================================
   모바일 (≤720px) — MCP 화면 (Intro / Generator / Builder / List).
   사이드바는 AI채팅(LlmChat) 패턴 차용: 기본 접힘(레일), 펼치면 오버레이 드로어.
   공유 셸(.prompt__*, .prompt-list__*)을 다른 기능과 공유하므로 .mcp-page 로 스코프.
   그리드는 minmax(0,1fr) — 긴 콘텐츠가 트랙을 밀어 오버플로/잘리는 것 방지.
   ======================================================================== */
@media (max-width: 720px) {
  /* 레이아웃 — 섹션 내비는 글로벌 햄버거 드로어로 이동, 본문만 풀폭 (프롬프트와 동일) */
  .mcp-page .prompt__layout {
    margin: 0 8px;
    flex-direction: column;
  }
  /* MCP 섹션 사이드바는 모바일에서 숨김
     (알아보기/AI 생성/나만의 MCP 만들기/내 MCP 목록은 글로벌 드로어의 'MCP' 펼침 항목에서 처리) */
  .mcp-page .prompt__sidebar { display: none; }

  .mcp-page .prompt__content {
    padding: 20px 14px;
    gap: 28px;
  }

  .mcp-page .prompt-intro__h1 {
    font-size: 22px;
    line-height: 32px;
  }

  /* McpIntro — 비교/기법 카드 그리드 1열 */
  .mcp-page .mcp-intro__onoff-grid-outer,
  .mcp-page .mcp-intro__onoff-grid,
  .mcp-page .prompt-intro__grid--2,
  .mcp-page .prompt-intro__grid--4,
  .mcp-page .prompt-intro__grid--5 {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  /* McpList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */
  .mcp-page .mcp-list__cards--grid,
  .mcp-page .mcp-list__cards--list {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .mcp-page .prompt-list__stats-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .mcp-page .prompt-list__stats {
    flex-wrap: wrap;
    gap: 6px 8px;
  }

  .mcp-page .prompt-list__filter-right {
    width: 100%;
    flex-wrap: wrap;
  }

  .mcp-page .prompt-list__search {
    flex: 1 1;
    width: auto;
    min-width: 0;
  }

  .mcp-page .prompt-list__view-toggle {
    display: none;
  }

  /* McpGenerator — 2-pane(작성 360px + 캔버스) → 세로 스택, 높이 고정 해제 */
  .mcp-page .mcp-gen__main {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }

  .mcp-page .mcp-gen__composer {
    width: auto;
    border-right: 0;
    border-bottom: 1px solid var(--fg-line);
  }

  /* 캔버스 = 스택 시 풀폭 (데스크탑 width:50% 가 모바일에서 좁은 칼럼으로 찌그러지는 버그) */
  .mcp-page .mcp-gen__canvas {
    width: auto;
    border-left: 0;
  }
  .mcp-page .mcp-gen__canvas-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 생성 결과 도구 카드 — 모바일은 1열 (2열은 좁아 이름·배지·설명·추천사유가 욱여넣어짐) */
  .mcp-page .mcp-gen__form-tools {
    grid-template-columns: 1fr;
  }

  .mcp-page .mcp-gen__suggestions {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Mcp.css"],"names":[],"mappings":"AAAA;;;;6EAI6E;;AAE7E,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;;AAGA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;6EAE6E;;AAE7E;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,uCAAuC;EACvC,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;;EAEE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;6EAE6E;;AAE7E;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA,gFAAgF;;AAEhF;;6EAE6E;;AAE7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE;;;IAGE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;;;6EAK6E;AAC7E;EACE,qDAAqD;EACrD;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;mEACiE;EACjE,6BAA6B,aAAa,EAAE;;EAE5C;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;;;;;IAKE,qCAAqC;IACrC,SAAS;EACX;;EAEA,wCAAwC;EACxC;;IAEE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,4DAA4D;EAC5D;IACE,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uCAAuC;EACzC;;EAEA,4DAA4D;EAC5D;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,wDAAwD;EACxD;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* ========================================================================\n   Mcp — MCP 도구 영역\n   사이드바·인트로 공통 스타일은 Prompt.css 재사용 (.prompt__sidebar / .prompt-intro__*)\n   비교 표는 Knowledge.css의 .knowledge-intro__vs-* 재사용\n   ======================================================================== */\n\n/* ───────── ON/OFF 비교 카드 ───────── */\n.mcp-intro__onoff-grid-outer {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.mcp-intro__onoff {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.mcp-intro__onoff-head {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.mcp-intro__onoff-q-icon {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-intro__onoff-question {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1.5;\n}\n\n.mcp-intro__onoff-source {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n.mcp-intro__onoff-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.mcp-intro__onoff-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: var(--fg-bg-card);\n  border-radius: 8px;\n}\n\n.mcp-intro__onoff-col--on {\n  background: var(--fg-bg-vs-green);\n}\n\n.mcp-intro__onoff-col p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-intro__onoff-label {\n  align-self: flex-start;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.mcp-intro__onoff-label--off {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-text-gray);\n}\n\n.mcp-intro__onoff-label--on {\n  background: rgba(98, 147, 81, 0.15);\n  color: var(--fg-class-green);\n}\n\n\n/* ========================================================================\n   McpList — 내 MCP 목록 (Figma 75:9500)\n   ======================================================================== */\n\n.mcp-list__cards {\n  display: grid;\n  gap: 20px;\n}\n\n.mcp-list__cards--grid {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.mcp-list__cards--list {\n  grid-template-columns: 1fr;\n}\n\n@media (max-width: 1440px) {\n  .mcp-list__cards--grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1280px) {\n  .mcp-list__cards--grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n\n.mcp-list__card {\n  display: flex;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.mcp-list__card:hover {\n  border-color: var(--fg-button);\n}\n\n.mcp-list__card--selected {\n  border-color: var(--fg-side-hover);\n  box-shadow: 0 0 0 1px var(--fg-side-hover);\n}\n\n.mcp-list__card-check {\n  flex-shrink: 0;\n  padding-top: 4px;\n}\n\n.mcp-list__card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mcp-list__card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mcp-list__card-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mcp-list__card-date {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.mcp-list__card-sub {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-list__tools {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.mcp-list__tool {\n  padding: 4px 6px;\n  background: var(--fg-bg-liteblue);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.mcp-list__actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n/* ========================================================================\n   McpGenerator — AI MCP 생성 (Figma 75:9010)\n   ======================================================================== */\n\n.mcp-gen__main {\n  display: flex;\n  padding: 0;\n  overflow: hidden;\n  /* layout 의 min-height 와 동일하게 강제 — 콘텐츠가 늘어나도 page scroll 이 생기지 않도록 */\n  height: calc(100vh - 52px);\n}\n\n/* 좌측 작성 패널 */\n.mcp-gen__composer {\n  width: 360px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 30px 24px;\n  background: var(--fg-bg-card);\n  border-right: 1px solid var(--fg-line);\n  overflow-y: auto;\n}\n\n.mcp-gen__composer-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mcp-gen__composer-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  flex: 1;\n}\n\n.mcp-gen__composer-lead {\n  margin: 0 0 4px;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-gray);\n}\n\n.mcp-gen__composer-label {\n  margin: 8px 0 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-gen__composer-btn {\n  align-self: stretch;\n  justify-content: center;\n}\n\n.mcp-gen__suggestions {\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mcp-gen__suggestion {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-gen__suggestion:hover {\n  border-color: var(--fg-button);\n}\n\n.mcp-gen__suggestion-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mcp-gen__suggestion-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-gen__suggestion-summary {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  line-height: 1.5;\n}\n\n/* 우측 캔버스 */\n.mcp-gen__canvas {\n  /* flex: 6 1 0; */\n  width:50%;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.mcp-gen__canvas-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  padding: 8px 16px;\n  background: var(--fg-bg-toolbar);\n  border-bottom: 1px solid var(--fg-line);\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.mcp-gen__canvas-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.mcp-gen__canvas-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-gen__canvas-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* 세그먼트 그룹 (탭처럼 묶인 chip 묶음) */\n.mcp-gen__chip-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 1px;\n}\n\n.mcp-gen__chip-group .mcp-gen__chip--seg {\n  border-radius: 0;\n}\n\n.mcp-gen__chip-group .mcp-gen__chip--seg:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.mcp-gen__chip-group .mcp-gen__chip--seg:last-child {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n/* 기본 chip — lite 배경 + purple text */\n.mcp-gen__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--fg-button-hover);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-gen__chip:hover {\n  filter: brightness(0.97);\n}\n\n.mcp-gen__chip--icon-only {\n  padding: 5px 7px;\n}\n\n/* active 세그먼트 + primary 단독 — purple 배경 + white text */\n.mcp-gen__chip--active,\n.mcp-gen__chip--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.mcp-gen__chip--active:hover,\n.mcp-gen__chip--primary:hover {\n  background: var(--fg-button-hover);\n  color: #fff;\n}\n\n.mcp-gen__canvas-body--filled {\n  display: block !important;\n  padding: 24px;\n}\n\n.mcp-gen__form {\n  max-width: 960px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.mcp-gen__form-badge {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: var(--fg-bg-step-active);\n  color: var(--fg-side-hover);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.mcp-gen__form-explanation {\n  margin: 0;\n  padding: 12px 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.mcp-gen__form-tools {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  padding: 8px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n\n.mcp-gen__tool-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-gen__tool-card:hover {\n  border-color: var(--fg-button);\n}\n\n.mcp-gen__tool-card--checked {\n  background: var(--fg-bg-step-active);\n  border-color: var(--fg-side-hover);\n}\n\n.mcp-gen__tool-check {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  background: #c2c2c2;\n  border-radius: 4px;\n  margin-top: 2px;\n}\n\n.mcp-gen__tool-card--checked .mcp-gen__tool-check {\n  background: var(--fg-side-hover);\n}\n\n.mcp-gen__tool-card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mcp-gen__tool-card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mcp-gen__tool-card-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-gen__tool-card-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  background: var(--fg-side-hover);\n  color: #fff;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mcp-gen__tool-card-desc {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  line-height: 1.45;\n}\n\n.mcp-gen__tool-card-reason {\n  margin: 4px 0 0;\n  padding: 6px 8px;\n  background: rgba(0, 0, 0, 0.03);\n  border-left: 2px solid var(--fg-side-hover);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.mcp-gen__canvas-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  background: #fafafa;\n  padding: 40px;\n  display: grid;\n  place-items: center;\n}\n\n.mcp-gen__canvas-empty,\n.mcp-gen__canvas-result {\n  text-align: center;\n  color: var(--fg-text-gray);\n  font-size: 15px;\n  line-height: 24px;\n}\n\n.mcp-gen__canvas-result p {\n  margin: 0 0 8px;\n}\n\n.mcp-gen__hint {\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   McpBuilder — 나만의 MCP 만들기 (Figma 75:9361)\n   ======================================================================== */\n\n.mcp-builder__panel {\n  /* flex: 4 1 0; */\n  width: 50%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 24px;\n  background: var(--fg-bg-card);\n  border-right: 1px solid var(--fg-line);\n  overflow-y: auto;\n}\n\n.mcp-builder__panel-head {\n  text-align: center;\n  border-bottom: 1px solid var(--fg-line);\n  padding-bottom: 12px;\n}\n\n.mcp-builder__panel-eyebrow {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__panel-sub {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.mcp-builder__tabs {\n  display: flex;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.mcp-builder__tab {\n  flex: 1;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: center;\n  margin-bottom: -1px;\n  transition: var(--transition-fast);\n}\n\n.mcp-builder__tab p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__tab-sub {\n  font-size: 12px !important;\n  color: var(--fg-text-gray) !important;\n  margin-top: 2px !important;\n}\n\n.mcp-builder__tab--active {\n  border-bottom-color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n.mcp-builder__search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px 7px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n}\n\n.mcp-builder__search>svg {\n  flex-shrink: 0;\n  color: var(--fg-text-gray);\n}\n\n.mcp-builder__count {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__count b {\n  color: var(--fg-button);\n  font-weight: 700;\n  margin-right: 2px;\n}\n\n.mcp-builder__count span {\n  color: var(--fg-text-gray);\n  margin-left: 2px;\n}\n\n.mcp-builder__count-cat {\n  margin-left: 6px !important;\n  color: var(--fg-button) !important;\n  font-weight: 600;\n}\n\n/* 카테고리 필터 칩 */\n.mcp-builder__cat-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 4px 0 10px;\n}\n\n.mcp-builder__cat-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-builder__cat-chip:hover:not(:disabled) {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n}\n\n.mcp-builder__cat-chip--active {\n  background: var(--fg-button);\n  border-color: var(--fg-button);\n  color: #fff;\n}\n\n.mcp-builder__cat-chip:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.mcp-builder__cat-chip-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 18px;\n  height: 16px;\n  padding: 0 5px;\n  background: var(--fg-bg-litepp);\n  color: var(--fg-text-gray);\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 999px;\n  line-height: 1;\n}\n\n.mcp-builder__cat-chip--active .mcp-builder__cat-chip-count {\n  background: rgba(255, 255, 255, 0.25);\n  color: #fff;\n}\n\n/* 도구 카드 그리드 (1열) */\n.mcp-builder__tool-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 6px;\n}\n\n.mcp-builder__tool-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  text-align: left;\n  font-family: inherit;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-builder__tool-card:hover {\n  border-color: var(--fg-text-gray);\n}\n\n.mcp-builder__tool-card--selected {\n  background: #fff;\n  border-color: var(--fg-text-basic);\n}\n\n.mcp-builder__tool-check {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-gray);\n}\n\n.mcp-builder__tool-card--selected .mcp-builder__tool-check {\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__tool-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mcp-builder__tool-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mcp-builder__tool-cat {\n  flex-shrink: 0;\n  align-self: flex-start;\n  padding: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  color: #fff;\n  background: var(--fg-text-gray);\n  border-radius: 4px;\n}\n\n.mcp-builder__tool-cat--utility {\n  background: #e48be3;\n}\n\n.mcp-builder__tool-cat--web {\n  background: #67d3eb;\n}\n\n.mcp-builder__tool-cat--compute {\n  background: #ff6e69;\n}\n\n.mcp-builder__tool-cat--file {\n  background: #bab361;\n}\n\n.mcp-builder__tool-cat--realtime {\n  background: #44e6ad;\n}\n\n.mcp-builder__tool-cat--external {\n  background: #9b92e8;\n}\n\n.mcp-builder__tool-desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 일반 탭 폼 */\n.mcp-builder__form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mcp-builder__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mcp-builder__field>span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__input,\n.mcp-builder__textarea {\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  outline: none;\n  resize: vertical;\n}\n\n.mcp-builder__input:focus,\n.mcp-builder__textarea:focus {\n  border-color: var(--fg-button);\n}\n\n/* 우측 캔버스 본문 */\n.mcp-builder__canvas-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 30px 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.mcp-builder__canvas-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.mcp-builder__canvas-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__canvas-sub {\n  margin: 4px 0 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.mcp-builder__canvas-count {\n  flex-shrink: 0;\n  padding: 6px 10px;\n  background: var(--fg-bg-mychat);\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--fg-button-hover);\n}\n\n.mcp-builder__canvas-count b {\n  margin-left: 4px;\n  font-weight: 700;\n}\n\n/* 선택된 도구 칩들 */\n.mcp-builder__chip-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.mcp-builder__selected-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 4px 4px 10px;\n  background: var(--fg-bg-mychat);\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__selected-chip button {\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.mcp-builder__selected-chip button:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-anti-red);\n}\n\n.mcp-builder__chip-empty {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n/* 실행 흐름 */\n.mcp-builder__flow {\n  margin-top: 12px;\n}\n\n.mcp-builder__flow-title {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__flow-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mcp-builder__flow-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n\n.mcp-builder__flow-num {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-numbering-bg);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 9999px;\n}\n\n.mcp-builder__flow-text {\n  margin: 0;\n  flex: 1;\n  font-size: 15px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__flow-tag {\n  flex-shrink: 0;\n  padding: 4px 8px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 6px;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n}\n\n/* (MCP 공유 관리 모달 → src/components/ShareModal.js + src/css/ShareModal.css 로 이관) */\n\n/* ========================================================================\n   McpBuilder — 테스트 패널 (구성/테스트 모드 토글)\n   ======================================================================== */\n\n.mcp-builder__mode-tabs {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px;\n  background: var(--fg-bg-content);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n}\n\n.mcp-builder__mode-tab {\n  padding: 6px 14px;\n  background: transparent;\n  border: 0;\n  border-radius: 7px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-builder__mode-tab:hover {\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__mode-tab--active {\n  background: #fff;\n  color: var(--fg-text-basic);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.mcp-builder__canvas-body--test {\n  gap: 12px;\n  overflow: hidden;\n  /* 부모의 overflow-y:auto를 끄고, 안쪽 scroller가 자체 스크롤 */\n}\n\n.mcp-builder__mcp-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  user-select: none;\n}\n\n.mcp-builder__mcp-toggle input {\n  margin: 0;\n  cursor: pointer;\n  accent-color: var(--fg-button);\n}\n\n.mcp-builder__test-tools-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--fg-bg-content);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  flex-wrap: wrap;\n}\n\n.mcp-builder__test-tools-label {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-gray);\n  letter-spacing: 0.02em;\n}\n\n.mcp-builder__test-tools-label b {\n  color: var(--fg-text-basic);\n  font-weight: 700;\n}\n\n.mcp-builder__test-tools-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.mcp-builder__test-tools-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  max-width: 220px;\n}\n\n.mcp-builder__test-tools-chip-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.mcp-builder__test-tools-chip-cat {\n  flex-shrink: 0;\n  padding: 1px 6px;\n  background: var(--fg-bg-content);\n  color: var(--fg-text-gray);\n  font-size: 10px;\n  font-weight: 600;\n  border-radius: 999px;\n  text-transform: lowercase;\n}\n\n.mcp-builder__test-notice {\n  margin: 0;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  background: var(--fg-bg-content);\n  border: 1px dashed var(--fg-line);\n  border-radius: 10px;\n}\n\n.mcp-builder__test-notice--warning {\n  color: var(--fg-anti-red);\n  background: rgba(239, 68, 68, 0.06);\n  border-color: rgba(239, 68, 68, 0.3);\n  border-style: solid;\n}\n\n.mcp-builder__test-scroller {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 12px 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.mcp-builder__test-empty {\n  margin: auto;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n.mcp-builder__test-msg {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 88%;\n}\n\n.mcp-builder__test-msg--user {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n\n.mcp-builder__test-msg--assistant {\n  align-self: flex-start;\n  align-items: flex-start;\n}\n\n.mcp-builder__test-steps {\n  list-style: none;\n  margin: 0 0 4px;\n  padding: 10px 12px;\n  background: var(--fg-bg-content);\n  border: 1px solid var(--fg-line);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 520px;\n}\n\n.mcp-builder__test-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.mcp-builder__test-step-num {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-button);\n  color: #fff;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.mcp-builder__test-step-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.mcp-builder__test-step-action {\n  margin: 0;\n  font-weight: 600;\n}\n\n.mcp-builder__test-step-detail {\n  margin: 0;\n  color: var(--fg-text-gray);\n}\n\n.mcp-builder__test-bubble {\n  padding: 10px 14px;\n  border-radius: 14px;\n  font-size: 14px;\n  line-height: 22px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n.mcp-builder__test-bubble--user {\n  background: var(--fg-button);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.mcp-builder__test-bubble--assistant {\n  background: #fff;\n  color: var(--fg-text-basic);\n  border: 1px solid var(--fg-line);\n  border-bottom-left-radius: 4px;\n}\n\n.mcp-builder__test-bubble--error {\n  border-color: rgba(239, 68, 68, 0.4);\n  color: var(--fg-anti-red);\n}\n\n.mcp-builder__test-bubble--pending {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 14px;\n}\n\n.mcp-builder__test-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--fg-text-gray);\n  animation: mcpTestBounce 1.2s infinite ease-in-out;\n}\n\n.mcp-builder__test-dot:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.mcp-builder__test-dot:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes mcpTestBounce {\n\n  0%,\n  60%,\n  100% {\n    transform: translateY(0);\n    opacity: 0.5;\n  }\n\n  30% {\n    transform: translateY(-4px);\n    opacity: 1;\n  }\n}\n\n.mcp-builder__test-tools {\n  margin: 0 0 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--fg-button);\n  letter-spacing: 0.02em;\n}\n\n.mcp-builder__test-text {\n  margin: 0;\n}\n\n.mcp-builder__test-images {\n  margin-top: 8px;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.mcp-builder__test-image {\n  max-width: 240px;\n  max-height: 200px;\n  border-radius: 8px;\n  border: 1px solid var(--fg-line);\n  object-fit: contain;\n  background: #fff;\n}\n\n.mcp-builder__test-inputbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 10px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 14px;\n}\n\n.mcp-builder__test-input {\n  flex: 1;\n  min-height: 40px;\n  max-height: 160px;\n  padding: 8px 10px;\n  background: transparent;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-basic);\n  resize: none;\n}\n\n.mcp-builder__test-input:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.mcp-builder__test-send {\n  flex-shrink: 0;\n  padding: 9px 16px;\n  background: var(--fg-button);\n  color: #fff;\n  border: 0;\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.mcp-builder__test-send:hover:not(:disabled) {\n  filter: brightness(1.06);\n  box-shadow: 0 4px 8px rgba(86, 60, 240, 0.25);\n}\n\n.mcp-builder__test-send:disabled {\n  background: var(--fg-text-gray);\n  cursor: not-allowed;\n}\n\n/* ========================================================================\n   모바일 (≤720px) — MCP 화면 (Intro / Generator / Builder / List).\n   사이드바는 AI채팅(LlmChat) 패턴 차용: 기본 접힘(레일), 펼치면 오버레이 드로어.\n   공유 셸(.prompt__*, .prompt-list__*)을 다른 기능과 공유하므로 .mcp-page 로 스코프.\n   그리드는 minmax(0,1fr) — 긴 콘텐츠가 트랙을 밀어 오버플로/잘리는 것 방지.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 레이아웃 — 섹션 내비는 글로벌 햄버거 드로어로 이동, 본문만 풀폭 (프롬프트와 동일) */\n  .mcp-page .prompt__layout {\n    margin: 0 8px;\n    flex-direction: column;\n  }\n  /* MCP 섹션 사이드바는 모바일에서 숨김\n     (알아보기/AI 생성/나만의 MCP 만들기/내 MCP 목록은 글로벌 드로어의 'MCP' 펼침 항목에서 처리) */\n  .mcp-page .prompt__sidebar { display: none; }\n\n  .mcp-page .prompt__content {\n    padding: 20px 14px;\n    gap: 28px;\n  }\n\n  .mcp-page .prompt-intro__h1 {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* McpIntro — 비교/기법 카드 그리드 1열 */\n  .mcp-page .mcp-intro__onoff-grid-outer,\n  .mcp-page .mcp-intro__onoff-grid,\n  .mcp-page .prompt-intro__grid--2,\n  .mcp-page .prompt-intro__grid--4,\n  .mcp-page .prompt-intro__grid--5 {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  /* McpList — 카드 1열(그리드/리스트 공통) + 툴바 정리 */\n  .mcp-page .mcp-list__cards--grid,\n  .mcp-page .mcp-list__cards--list {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n\n  .mcp-page .prompt-list__stats-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .mcp-page .prompt-list__stats {\n    flex-wrap: wrap;\n    gap: 6px 8px;\n  }\n\n  .mcp-page .prompt-list__filter-right {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .mcp-page .prompt-list__search {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  .mcp-page .prompt-list__view-toggle {\n    display: none;\n  }\n\n  /* McpGenerator — 2-pane(작성 360px + 캔버스) → 세로 스택, 높이 고정 해제 */\n  .mcp-page .mcp-gen__main {\n    flex-direction: column;\n    height: auto;\n    overflow: visible;\n  }\n\n  .mcp-page .mcp-gen__composer {\n    width: auto;\n    border-right: 0;\n    border-bottom: 1px solid var(--fg-line);\n  }\n\n  /* 캔버스 = 스택 시 풀폭 (데스크탑 width:50% 가 모바일에서 좁은 칼럼으로 찌그러지는 버그) */\n  .mcp-page .mcp-gen__canvas {\n    width: auto;\n    border-left: 0;\n  }\n  .mcp-page .mcp-gen__canvas-title {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* 생성 결과 도구 카드 — 모바일은 1열 (2열은 좁아 이름·배지·설명·추천사유가 욱여넣어짐) */\n  .mcp-page .mcp-gen__form-tools {\n    grid-template-columns: 1fr;\n  }\n\n  .mcp-page .mcp-gen__suggestions {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
